import { Box, Text } from '@chakra-ui/react';

export const BoxPreview = () => {
  return (
    <Box>
      <Text>BoxPreview - Coming soon</Text>
    </Box>
  );
};
